import React from 'react';

const TypologyTable = ({ color, tipologias }) => (
    <table className="table table-striped table-condensed" style={{ border: `3px solid ${color}` }}>
        <thead>
            <tr>
                <td colSpan={1} className="text-center" style={{ backgroundColor: color, color: '#fff' }}></td>
                <td colSpan={3} className="text-center" style={{ backgroundColor: color, color: '#fff', padding: 7 }}>
                    M2 PRIVATIVO
                </td>
                <td colSpan={3} className="text-center" style={{ backgroundColor: color, color: '#fff', padding: 7 }}>
                    R$/M2 PRIVATIVO
                </td>
            </tr>
            <tr className="text-center" style={{ backgroundColor: color, color: '#fff' }}>
                <th className="text-center" style={{ color: '#fff' }}>Tipologia</th>
                <th className="text-center" style={{ color: '#fff' }}>Mínimo</th>
                <th className="text-center" style={{ color: '#fff' }}>Média</th>
                <th className="text-center" style={{ color: '#fff' }}>Máximo</th>
                <th className="text-center" style={{ color: '#fff' }}>Mínimo</th>
                <th className="text-center" style={{ color: '#fff' }}>Média</th>
                <th className="text-center" style={{ color: '#fff' }}>Máximo</th>
            </tr>
        </thead>
        <tbody>
            {tipologias.map((t, i) => (
                <tr className="text-center" key={i}>
                    <td style={{ whiteSpace: 'nowrap' }}>
                        {t.numero_quartos} {t.numero_quartos === 1 ? 'Dormitório' : 'Dormitórios'}
                    </td>
                    <td>{t.area_minima}</td>
                    <td>{t.area_media}</td>
                    <td>{t.area_maxima}</td>
                    <td>{t.valor_minimo_metro}</td>
                    <td>{t.valor_medio_metro}</td>
                    <td>{t.valor_maximo_metro}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default TypologyTable;
